export class SearchLocation {
  constructor(json = {}) {
    Object.assign(this, {
      id: json.id,
      lat: json.lat,
      lon: json.lon,
      locationName: json.name || json.main_text,
      placeId: json.place_id,
      mapBounds: json.map_bounds,
      timezone: json.timezone,
      type: json.type,
      calculatedRadiusMiles: json.calculated_radius_miles,
      calculatedRadiusKm: json.calculated_radius_km,
    });
  }
}
